import api from "@/api/api";
import lNapi from "@/api/longNovel";
import AnApi from "@/api/answer";
import SApi from "@/api/script";
import HApi from "@/api/hottc";
import data from "@/assets/data";
import { EventBus } from "@/utils/eventBus";
import { marked } from "marked";
import DOMPurify from "dompurify";
import { mapActions, mapMutations } from "vuex";
import store from "@/store";
// 通用的一些参数
export const myMixin = {
  data() {
    return {
      isStop: false, //表示是否停止生成
      openModal: false, //通用弹窗显示关闭控制器
      AICreateId: "", //ai生成前的id
      welcome: "welcome", //welcome
      nSearchKey: "nSearch", //小说写作搜索条件缓存key
      nChapterSearchKey: "nChapterSearch", //小说写作里面的章节列表分页参数条件key
      lNSeriesSearchKey: "lnSeriesSearch", //长篇小说写作分卷列表搜索条件缓存key
      lNChapterSearchKey: "lnChapterSearch", //长篇小说写作章节列表的搜索缓存key
      dSearchKey: "dSearch", //短剧小说写作搜索条件缓存key
      dChapterSearchKey: "dChapterSearch", //短剧小说写作里面的章节列表分页参数条件key
      rSearchKey: "rSearchKey", //作品回收站搜索条件缓存key
      mSearchKey: "mSearchKey", // 消息动态搜索条件key
      collectSearchKey: "collectSearchKey", //收藏列表搜索条件缓存key
      sessionIdKey: "ai_sessionId", //ai问答缓存key
      streamIndex: 0, //ai生成的索引
      debounceTimer: null, //ai生成定时器
      typingTimer: null, //打字机效果定时器
      streamStatus: false, //流式请求
      aiCreateContent: "", //ai生成后的内容
      scrollerRef: "editorOutline1",
      selectedIndex: -1, //鼠标悬停的索引
      selectedId: "",
      maxLableNum: 20, //最多标签的数量
      loginState: false, //登录状态
      AIStreamType: {
        //ai生成接口参数，默认ai写作:novel,短剧：script
        ftype: "script",
      },
      mixinUserInfo: null, //用户信息对象
      mixinNInfo: null, //小说信息，适用于中短长篇
      recallLoading: false, //长记忆加载状态
      nextChapterLoading: false, //下一步生成章纲加载状态
    };
  },
  methods: {
    getUserInfo() {
      store.dispatch("user/getUserInfo");
    },
    //获取用户信息，如果
    getUserLoginState(isShowLogin = true) {
      api
        .getUserinfo()
        .then((res) => {
          // console.log(res)
          if (res.code === 200) {
            this.loginState = false;
            this.mixinUserInfo = res.data;
          } else if (res.code == 401) {
            this.loginState = true;
            isShowLogin && EventBus.$emit("openLogin");
          }
        })
        .catch(() => {
          this.loginState = true;
          isShowLogin && EventBus.$emit("openLogin");
        });
    },
    //小说信息
    mixinNovelInfo(novelId, novelType = "novel") {
      if (novelType === "novel") {
        api.novelDetail(novelId).then((res) => {
          if (res.code === 200) {
            this.mixinNInfo = res.data;
          }
        });
      } else {
        lNapi.longNovelDetail({ id: novelId }).then((res) => {
          if (res.code === 200) {
            this.mixinNInfo = res.data;
          }
        });
      }
    },
    zsVip(userInfo = null) {
      if (this.mixinUserInfo || userInfo) {
        console.log("有用户信息");
        const vipItem = this.getUserTypeImg(this.mixinUserInfo || userInfo);
        console.log("看下用户类型=", vipItem);
        //是专业vip
        if (!["普通会员", "基础会员"].includes(vipItem.name)) {
          console.log("用户是专业会员");
          return true;
        }
        console.log("用户是普通会员或基础会员");
        return false;
      }
      console.log("没有用户信息=", this.mixinUserInfo);
      return false;
    },
    isOpenRecall(novelInfo) {
      console.log("小说信息=", novelInfo);
      if (!novelInfo) return false;
      return novelInfo.recall;
    },
    showLoginPage() {
      console.log(this.loginState);
      if (this.loginState) {
        EventBus.$emit("openLogin");
        return true;
      }
      return false;
    },
    //章节列表缓存key的组合
    getChapterSearchKey(typeKey, novelId) {
      return `${typeKey}_${novelId}`;
    },
    //移除md格式标签，在对带有html标签的文本变成【纯文本】
    removeMarkdownTags(markdownContent, openCount = true) {
      if (!markdownContent) return openCount ? 0 : "";
      // 将Markdown转换为HTML
      // console.log('markdownContent=',markdownContent)
      const htmlContent = marked(markdownContent);
      // console.log('htmlContent=',htmlContent)
      // 使用DOMPurify清理HTML（可选，如果你不介意保留一些安全的标签）
      const cleanHtml = DOMPurify.sanitize(htmlContent);
      // console.log('cleanHtml=',cleanHtml)
      // 将HTML转换为文本,先清除零宽字符
      let textContent = this.clearText(cleanHtml);
      //在移除html标签合并空格以及清空&nbsp;这些标签
      textContent = textContent
        .replace(/<[^>]+>/g, "")
        .replace(/\s+/g, "")
        .replace(/&[a-z]+;/g, "");
      if (openCount) {
        return textContent.length;
      }
      return textContent;
    },
    //通用格式化富文本
    stripHtmlTags(html) {
      if (!html) return "";

      let text = html;
      // 0.去除零宽字符
      text = text.replace(/[\u200B-\u200D\uFEFF\u200E\u200F]/g, "");
      // 1. 将 <p><br></p> 替换为 \n
      text = text.replace(/<p>\s*(<br>\s*)?<\/p>/gi, "\n");

      // 2. 移除所有行内标签（如 <span>, <strong>, <em> 等）
      text = text.replace(/<(\/)?(span|strong|em|b|i|a)[^>]*>/g, "");

      // 3. 将块级元素（<p>, <div>, <h1>-<h6>, <ul>, <li>, <br> 等）替换为 \n
      text = text.replace(
        /<(\/)?(div|h[1-6]|ul|ol|li|br|section|article|header|footer)[^>]*>/g,
        "\n"
      );

      // 4. 移除p标签，顺便处理p标签里面的一些属性（将 <p>内容</p> 变为 \n内容\n）：
      text = text.replace(/<\/p>/g, "\n").replace(/<\/?p>/g, "");

      // 5. 替换 转义符
      text = text
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&apos;/g, "'");
      // console.log('最终结果--------------');
      // console.log(text)
      return text;
    },
    //通用跳转到首页
    toHome() {
      // this.$router.replace('/'); // 替换当前路由，不留下历史记录
    },
    goBack() {
      this.$router.go(-1);
    },
    /**
     * @description 全局mixin里，一个停止ai生成前的消息框
     */
    cancelAi() {
      return new Promise((resolve, reject) => {
        this.$confirm("取消AI生成后会导致内容不完整，确定保存？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    removeHtmlTags(text) {
      // 移除所有HTML标签
      return (
        text
          .replace(/<\/?[^>]+(>|$)/g, "")
          // 移除try-catch代码块
          .replace(/\btry\s*\{[^}]*\}\s*catch\s*\([^)]*\)\s*\{[^}]*\}/g, "")
          // 移除可能残留的JavaScript函数调用
          .replace(/\w+\([^)]*\)/g, "")
      );
    },
    //获取仿写内容
    getFxContent(params = { key: "refer" }, callback) {
      const editItem = JSON.parse(sessionStorage.getItem("editItem"));
      if (editItem) {
        let data = {
          novelId: editItem.id,
          key: params.key,
        };
        api.getParams(data).then((res) => {
          if (res.code === 200) {
            //    this.fx = res.data
            console.log("请求仿写内容成功");
            callback && callback(res.data);
          }
        });
      } else {
        console.warn("没有小说id");
      }
    },
    //保存仿写内容
    saveFxContent(
      params = { key: "refer", name: "参考内容", content: "" },
      callback
    ) {
      const editItem = JSON.parse(sessionStorage.getItem("editItem"));
      if (editItem) {
        let data = {
          novelId: editItem.id,
          key: params.key,
          name: params.name,
          content: params.content,
        };
        api.saveParams(data).then((res) => {
          if (res.code === 200) {
            console.log("保存仿写内容成功");
            callback && callback();
          }
        });
      } else {
        console.warn("没有小说id");
      }
    },
    AIWrite({
      length = "",
      haveId = false,
      djold = false,
      djoldApi = false,
      type,
      params,
      data,
      success,
      warn,
      error,
    } = {}) {
      const callNovelHelpWrite = () => {
        //length新增流式工具
        if (length === "灵感") {
          HApi.subjectInspiration(type, data,params).then((res) => {
            if (res.code == 200) {
              success && success(res);
            } else {
              if (warn) {
                warn(res);
              } else {
                this.$message.warning(res.msg);
              }
            }
          });
        } else if (length === "流式工具") {
          api.getNovelstreamId(type, params).then((res) => {
            if (res.code == 200) {
              success && success(res);
            } else {
              if (warn) {
                warn(res);
              } else {
                this.$message.warning(res.msg);
              }
            }
          });
        }
        // else if (length === 'AI问答') {
        //     AnApi.answerCreate().then((res) => {
        //         if (res.code == 200) {
        //             success && success(res)
        //         } else {
        //             if (warn) {
        //                 warn(res)
        //             } else {
        //                 this.$message.warning(res.msg)
        //             }
        //         }
        //     })
        // }
        //长篇的只有id ai帮写，没有id还得是api里面的
        else if (length === "长" && haveId) {
          lNapi.longNovelHelpWriteId(type, params).then((res) => {
            if (res.code == 200) {
              success && success(res);
            } else {
              if (warn) {
                warn(res);
              } else {
                this.$message.warning(res.msg);
              }
            }
          });
        } else if (djold) {
          //短剧
          if (djoldApi) {
            api
              .getNovelstreamIds(type, params)
              .then((res) => {
                if (res.code == 200) {
                  success && success(res);
                } else {
                  if (warn) {
                    warn(res);
                  } else {
                    this.$message.warning(res.msg);
                  }
                }
              })
              .catch(() => {
                error && error();
              });
          } else {
            SApi.scriptAiCreateId(type, params, data)
              .then((res) => {
                if (res.code == 200) {
                  success && success(res);
                } else {
                  if (warn) {
                    warn(res);
                  } else {
                    this.$message.warning(res.msg);
                  }
                }
              })
              .catch(() => {
                error && error();
              });
          }
        } else {
          //中短篇，长篇非id参数
          let methodName = haveId ? "novelHelpWriteId" : "novelHelpWrite";
          api[methodName](type, params)
            .then((res) => {
              if (res.code == 200) {
                success && success(res);
              } else {
                if (warn) {
                  warn(res);
                } else {
                  this.$message.warning(res.msg);
                }
              }
            })
            .catch(() => {
              error && error();
            });
        }
      };
      api.aiCreateState().then((ac) => {
        if (!ac.data) {
          callNovelHelpWrite();
        } else {
          //弹窗
          this.$confirm(
            "当前有其他任务在执行中，是否终止其他任务开启当前任务",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "等一等",
              type: "warning",
            }
          )
            .then(() => {
              api.aiStopState().then((as) => {
                if (as.code === 200) {
                  this.$message.success("正在执行当前AI生成任务！");
                  //重新调用
                  callNovelHelpWrite();
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    //清空
    mixinClearTimer(status) {
      console.log("销毁定时器");
      if (status) {
        this.isStop = true;
      }
      clearTimeout(this.debounceTimer);
      clearInterval(this.typingTimer);
      this.streamIndex = 0;
      this.streamStatus = false;
      sessionStorage.removeItem("streamStatus");
    },
    /**
     * 请求AI流式内容
     * @param {String} id - 请求ID
     * @param {Object} callbacks - 回调函数
     * @param {Function} callbacks.success - 成功回调
     * @param {Function} callbacks.warn - 警告回调
     * @param {Function} callbacks.error - 错误回调
     * @param {Function} scrollRef - 滚动元素
     * @param {Function} callbacks.onTextUpdate - 自定义打字机内容回调
     * @param {Function} callbacks.onScrollRef - 自定义滚动
     */
    async getComStreamContent(
      id,
      {
        scrollRef = "editorOutline1",
        success,
        warn,
        error,
        speed = 20,
        onTextUpdate,
        onScrollRef,
      } = {}
    ) {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);

      this.debounceTimer = setTimeout(async () => {
        try {
          const res = await api.getStreamContent(id, this.streamIndex);
          if (res.code !== 200) {
            this.$message.warning(res.msg);
            this.mixinClearTimer();
            warn?.(res);
            return;
          }

          if (!res.data || res.data.length === 0) {
            // 如果没有数据，继续轮询（非递归）
            this.getComStreamContent(id, {
              scrollRef,
              success,
              warn,
              error,
              onTextUpdate,
              onScrollRef,
              speed,
            });
            return;
          }

          this.streamIndex += res.data.length;
          const combinedText = res.data
            .filter((item) => item !== "[DONE]")
            .join("");
          this.typewriter(
            combinedText,
            () => {
              if (res.data[res.data.length - 1] === "[DONE]") {
                this.$message.success("AI生成完成！");
                this.mixinClearTimer();
                this.getUserInfo();
                success?.(res);
              } else {
                // 继续获取下一批数据（非递归）
                this.getComStreamContent(id, {
                  scrollRef,
                  success,
                  warn,
                  error,
                  onTextUpdate,
                  onScrollRef,
                  speed,
                });
              }
            },
            {
              onTextUpdate,
              scrollRef,
              speed,
              onScrollRef,
            }
          );
        } catch (err) {
          this.streamStatus = false;
          error?.();
        }
      }, 500);
    },
    /**
     * 打字机效果
     * @param {String} text - 要显示的文字
     * @param {Function} callback - 完成回调
     * @param {String} scrollRef - 滚动容器的ref名称
     * @param {Number} speed - 打字速度(ms)
     * @param {Number} onTextUpdate - 自定义打字效果内容
     * @param {Number} onScrollRef - 自定义滚动
     */
    typewriter(
      text,
      callback,
      {
        scrollRef = "editorOutline1",
        speed = 20,
        onTextUpdate,
        onScrollRef,
      } = {}
    ) {
      let index = 0;

      if (this.typingTimer) clearInterval(this.typingTimer);
      this.typingTimer = setInterval(() => {
        if (index < text.length) {
          this.aiCreateContent += text[index];
          // 更新内容
          if (onTextUpdate) {
            onTextUpdate(text[index]);
          }
          index++;
          // 滚动逻辑
          if (onScrollRef) {
            onScrollRef(scrollRef);
          } else {
            this.toScrollRef(scrollRef);
          }
        } else {
          clearInterval(this.typingTimer);
          callback && callback();
        }
      }, speed);
    },
    //滚动到最下
    toScrollRef(scrollRef = "editorOutline1") {
      this.$nextTick(() => {
        const container = this.$refs[scrollRef];
        if (container) {
          container.scrollTop = container.scrollHeight; // 设置滚动位置到底部
        }
      });
    },
    //只获得章、卷、篇等设定的列表正则
    createChapterMatcher(keywords = ["章"], extend = "") {
      // 将关键词数组转换为[章卷节]这样的形式
      const keywordPart =
        keywords.length > 1 ? `[${keywords.join("")}]` : keywords[0];

      return new RegExp(
        `^${extend}\\s*第\\s*([零一二两三四五六七八九十百千万]+|\\d+)\\s*${keywordPart}\\s*.*(?:\\n(?!第\\s*([零一二两三四五六七八九十百千万]+|\\d+)\\s*${keywordPart}).*)*`,
        "gm"
      );
    },
    // 解析内容
    parseTxtToJson(
      txtContent,
      {
        isExtractName = false,
        nLen = 0,
        detection = ["章"],
        isSkipEmpty = false,
        tLen = 0,
        cLen = 0,
        cDes = "",
        isSet = false,
        extend = "",
      } = {}
    ) {
      let chapterPattern = null,
        chapterMatches = null,
        textLine = "";
      // false表示不需要作品名称，只需要里面的章节列表
      txtContent = this.clearText(txtContent);
      txtContent = txtContent.replace(/\*+/g, "").replace(/#+/g, "");
      console.log("extend=", extend);
      console.log("txtContent=", txtContent);
      console.log("detection=", detection);
      console.log("extend=", extend);
      if (!isExtractName) {
        chapterPattern = this.createChapterMatcher(detection, extend);
        console.log("chapterPattern=", chapterPattern);
        chapterMatches = txtContent.match(chapterPattern);
        console.log("chapterMatches=", chapterMatches);
        textLine = chapterMatches ? chapterMatches.join("\n") : "";
        console.log("isExtractName==false", textLine);
      } else {
        textLine = txtContent;
        console.log("isExtractName==true", textLine);
      }
      textLine = textLine.replace(/```|\*{3}/g, "");
      const lines = textLine.split("\n").filter((line) => line.trim() !== "");
      console.log(lines);
      if (lines.length === 0) {
        this.$message.error("内容为空");
        return;
      }
      // 存放作品名和章节
      let chapters = [];
      // 提取作品名
      let workName = "";
      // 标题内容索引
      const index = isExtractName ? 1 : 0;

      if (isExtractName) {
        workName = lines[0].trim();
      }

      if (nLen && workName.length > nLen) {
        this.$message.error(`作品名不能超过${nLen}字`);
        return;
      }

      let currentChapter = null;
      const chapterTitles = new Set(); // 用于检测重复标题

      for (let i = index; i < lines.length; i++) {
        let line = this.clearZeroWidthText(lines[i].trim());
        if (line) {
          line = this.removeHtmlTags(line);
          //移除星号井号
          line = line.replace(/\*+/g, "").replace(/#+/g, "");
        }
        console.log("line=", line);
        const pattern = new RegExp(
          `^${extend}\\s*第\\s*([零一二两三四五六七八九十百千万]+|\\d+)\\s*${detection[0]}\\s*.+`
        );
        // 检测是否是章节标题行（以"第X章"开头）
        if (line.match(pattern)) {
          console.log("extend=", extend, "-------标题：", line);
          // 验证标题长度
          if (tLen && line.length > tLen) {
            this.$message.error(`标题"${line}"超过${tLen}字限制`);
            return;
          }

          // 检查是否重复
          if (isSet) {
            if (chapterTitles.has(line)) {
              this.$message.error(`发现重复章节标题: ${line}`);
              chapterTitles.add(line);
            }
          }

          // 保存前一章（如果有）
          if (currentChapter) {
            // 验证内容长度
            if (cLen && currentChapter.content.length > cLen) {
              this.$message.error(
                `标题"${currentChapter.title}"内容超过${cLen}字限制`
              );
              return;
            }
            if (currentChapter.content.length === 0) {
              // this.$message.error(`章节"${currentChapter.title}"内容不能为空`);
              // return;
              if (isSkipEmpty) {
                currentChapter.content = "";
              } else {
                continue;
              }
            }
            // console.log('进行下一个不会在执行下来');
            chapters.push(currentChapter);
          }

          // 开始新章节
          currentChapter = {
            chapter: chapters.length + 1, // 章节序号自动递增
            title: line,
            content: "",
          };
        } else if (currentChapter) {
          // 添加内容到当前章节
          if (currentChapter.content) {
            currentChapter.content += "\n" + line;
          } else {
            currentChapter.content = line;
          }
        } else {
          this.$message.error("没有找到有效的标题内容");
          // throw new Error('在作品名后没有找到有效的章节标题')
          return;
        }
      }

      // 添加最后一章
      if (currentChapter) {
        if (cLen && currentChapter.content.length > cLen) {
          this.$message.error(
            `标题"${currentChapter.title}"内容超过${cLen}字限制`
          );
          // throw new Error(`章节"${currentChapter.title}"内容超过5万字限制`)
          return;
        }
        if (currentChapter.content.length === 0) {
          // this.$message.error(`章节"${currentChapter.title}"内容不能为空`);
          // return;
          if (isSkipEmpty) {
            currentChapter.content = "";
          }
        }
        chapters.push(currentChapter);
      }
      if (!chapters.length) {
        this.$message.error(`未检测到标题和内容`);
        return;
      }
      //处理chapters里面的title，如果有extend 那就移除掉title前缀
      if (extend) {
        chapters = chapters.map((item) => ({
          ...item,
          title: item.title.replace(extend, ""),
        }));
      }
      let data = {
        name: workName, //书名，如果开启相关配置就有检测
        chapters, //集合，包含标题内容索引
        setChapters: chapterTitles, //包含重复的标题内容
      };
      return data;
    },
    //解析后数据处理
    parseJSONToFormData(text = "", { ycCollback, wcCollback, params } = {}) {
      console.log("params=", params);
      if (!text) return;
      let resultText = this.parseTxtToJson(text, params);
      console.log("解析后的结果=", resultText);
      if (resultText && Object.keys(resultText).length > 0) {
        ycCollback && ycCollback(resultText);
      } else {
        wcCollback && wcCollback();
      }
    },
    getUserTypeImg(userInfo) {
      if (!userInfo) {
        return {};
      }
      let obj = {};
      //普通会员
      if (userInfo.vipType == "common") {
        obj.name = "普通会员";
        obj.img = data.userVipImg[0];
        return obj;
      }
      //基础会员
      else if (userInfo.vipType == "cmember") {
        obj.name = "基础会员";
        obj.img = data.userVipImg[1];
        return obj;
      }
      //月度会员
      else if (userInfo.vipType == "month") {
        obj.name = "月度会员";
        obj.img = data.userVipImg[2];
        return obj;
      }
      //季度会员
      else if (userInfo.vipType == "three_months") {
        obj.name = "季度会员";
        obj.img = data.userVipImg[3];
        return obj;
      }
      //半年会员
      else if (userInfo.vipType == "half_year") {
        obj.name = "半年会员";
        obj.img = data.userVipImg[4];
        return obj;
      }
      //年度会员
      else if (userInfo.vipType == "year" || userInfo.vipType == "vipyear") {
        obj.name = "年度会员";
        obj.img = data.userVipImg[5];
        return obj;
      }
      //永久会员
      else if (
        ["perpetual", "year_ensure", "year_coach"].includes(userInfo.vipType)
      ) {
        obj.name = "永久会员";
        obj.img = data.userVipImg[6];
        return obj;
      } else {
        //其他永久会员
        obj.name = "永久会员";
        obj.img = data.userVipImg[6];
        return obj;
      }
    },
    //清除零宽字符
    clearText(text) {
      return text.replace(/[\u200B-\u200D\uFEFF\u200E\u200F]/g, "");
    },
    //清除零宽字符
    clearZeroWidthText(text) {
      return text.replace(/[\u200B-\u200D\uFEFF\u200E\u200F]/g, "");
    },
    escapeControlCharacters(str) {
      if (!str) return;
      return this.clearText(str).replace(/[\x00-\x1F\x7F-\x9F]/g, "");
    },
    titleContentFormat(detection = "章", extend = "") {
      return new RegExp(
        `^${extend}\\s*第\\s*([零一二两三四五六七八九十百千万]+|\\d+)\\s*${detection}\\s*.+`
      );
    },
    //中文逗号换成英文逗号
    convertCommas(text) {
      return text.replace(/，/g, ",");
    },
    //页面跳转，根据索引来进行操作
    routerPathJump(i) {
       this.getUserLoginState(false)
      if (i == 0) {
        this.$router.push({ path: "/" });
      } else if (i == 1) {
        sessionStorage.removeItem("editItem");
        localStorage.removeItem(this.nSearchKey);
        localStorage.removeItem(this.nChapterSearchKey);
        this.$router.push({ path: "/novel" });
      } else if (i == 2) {
        sessionStorage.removeItem("editItem");
        localStorage.removeItem(this.dSearchKey);
        localStorage.removeItem(this.dChapterSearchKey);
        this.$router.push({ path: "/scriptList" });
      } else if (i == 3) {
        //通配符移除
        Object.keys(sessionStorage).forEach((key) => {
          if (key.includes("_csText")) {
            sessionStorage.removeItem(key);
          }
          if (key.includes("_fxText")) {
            sessionStorage.removeItem(key);
          }
        });
        sessionStorage.removeItem("apartStatus");
        this.$router.push({ path: "/novel_apart" });
      } else if (i == 4) {
        setTimeout(() => {
          if(this.showLoginPage()) return
           this.$router.push({ path: "/hottc" });
        }, 100);
      } else if (i == 5) {
        this.$router.push({ path: "/classroom" });
      } else if (i == 6) {
        this.$router.push({ path: "/AIInterlocutor" });
      } else if (i == 7) {
        this.$router.push({ path: "/message" });
      } else if (i == 8) {
         this.$router.push({ path: "/contactUs" });
      }
    },
  },
};
